import { createFileRoute } from "@tanstack/react-router";
import AdminProgramDetailPage from "@/pages/admin/programs/detail";
import { useProgramsPermissions } from "@/pages/admin/programs";

export const Route = createFileRoute("/app/admin/programs/$programId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { programId } = Route.useParams();
  const {
    programs,
    userCanEditAllPrograms,
    userCanViewAllPrograms,
    userCanEditAllSets,
    userCanViewAllSets,
  } = useProgramsPermissions();

  return (
    <AdminProgramDetailPage
      program={programs.data[programId]}
      userCanEditAllPrograms={userCanEditAllPrograms}
      userCanViewAllPrograms={userCanViewAllPrograms}
      userCanEditAllSets={userCanEditAllSets}
      userCanViewAllSets={userCanViewAllSets}
    />
  );
}
